import { render, staticRenderFns } from "./LastName.vue?vue&type=template&id=57927814"
import script from "./LastName.vue?vue&type=script&lang=ts"
export * from "./LastName.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports